
  import { Component } from 'vue-property-decorator'
  import BaseBar from '@/layouts/BaseBar'

@Component
  export default class AppBar extends BaseBar {
  }
